export const base_url='https://restapi-ecomm-new.onrender.com/api/'

// export const base_url='http://localhost:5000/api/'